import React from 'react';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';

interface SoftwareInterestModalProps {
  isOpen: boolean;
  onClose: () => void;
  onYes: () => void;
  onNo: () => void;
}

const SoftwareInterestModal: React.FC<SoftwareInterestModalProps> = ({
  isOpen,
  onClose,
  onYes,
  onNo
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">
            Quick Question
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="mb-8">
          <p className="text-lg text-gray-700 mb-4">
            Are you interested to buy salon/spa software to grow your business?
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
        <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onNo}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
          >
            No, I Am Looking for Digital Marketing to Get More Leads
          </motion.button><motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onYes}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
          >
            Yes, I Am Interested to Buy Software to Grow my Salon/SPA
          </motion.button>
          
          
        </div>
      </motion.div>
    </div>
  );
};

export default SoftwareInterestModal;
